"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 ----------------- highlightText function output example -----------------------

 Original Keyword = "Honda Civic Coup w Honda/Sensing"

 User Input = "Hon"
 Return highlightedText = "<span class="search-result-bold-phrase">Hon</span>da Civic Coup w <span class="search-result-bold-phrase">Hon</span>da/Sensing"

 User Input = ""
 Return keyword = "Honda Civic Coup Honda/Sensing"
 */
function highlightText(keyword, searchString) {
    if (!searchString)
        return keyword;
    var startTag = '<span class="font-bold">';
    var endTag = '</span>';
    var re = new RegExp(searchString, 'gi');
    return keyword.replace(re, startTag + '$&' + endTag);
}
exports.default = highlightText;
//# sourceMappingURL=highlightText.js.map